<template>
  <PanelHeading
    :title="currentSite.address"
    :subtitle="title"
    :description="description"
    header
    headerColor="gray"
    wave
  >
    <template #description v-if="hasDescriptionSlot">
      <slot name="description" />
    </template>
  </PanelHeading>
</template>

<script>
import PanelHeading from '@/components/PanelHeading.vue'
import useCurrentSite from '@/store/currentSite'

export default {
  name: 'DomainsHeading',
  components: {
    PanelHeading
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    }
  },
  setup () {
    const currentSite = useCurrentSite()

    return { currentSite }
  },
  computed: {
    hasDescriptionSlot () {
      return !!this.$slots.description
    }
  }
}
</script>
